import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserService } from '../user.service';
import { BaseUser } from '../models/user';

@Injectable({ providedIn: 'root' })
export class WaitForUserGuard {
  constructor(private userService: UserService<BaseUser>) {}

  canActivate(): Observable<boolean> {
    return this.userService.mainUser$.pipe(
      filter(mainUser => !!mainUser),
      map(result => !!result),
    );
  }

  canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
